import {RecipientContactMatchModel} from '../../../../models/api/recipientMatchModel';
import {TeammateModel} from '../../../../models/api/teammateModel';
import {TypedRowValue} from '../../dropdowns/source/dropdownSource';

export enum MentionDropdownItemTypesEnum {
  TEAMMATE_HEADER = 'TEAMMATE_HEADER',
  TEAMMATE = 'TEAMMATE',
  VISITOR_HEADER = 'VISITOR_HEADER',
  VISITOR = 'VISITOR',
}

export type HeaderRow = TypedRowValue<
  MentionDropdownItemTypesEnum.TEAMMATE_HEADER | MentionDropdownItemTypesEnum.VISITOR_HEADER,
  undefined
>;
export type VisitorRow = TypedRowValue<MentionDropdownItemTypesEnum.VISITOR, RecipientContactMatchModel>;
export type TeammateRow = TypedRowValue<MentionDropdownItemTypesEnum.TEAMMATE, TeammateModel>;

export type MentionDropdownTypedRowValue = HeaderRow | VisitorRow | TeammateRow;
